'use strict'

const Convert = (value) => {
    const options1 = { style: 'currency', currency: 'COP' }
    const numberFormat1 = new Intl.NumberFormat('es-CO', options1)
    return numberFormat1.format(value)
}

module.exports = Convert



// WEBPACK FOOTER //
// ./src/utils/ConvertPriceNumber.js